import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat, findArrayObject, amountFormatOnly, isEmpty, getDateInStringDDMMMYYYY, numberWithCommas, numberWithCommasInput, checkNumberOnly, replaceCommas, sortByDisplay, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../Dialog/Dialog';
import Radio from '@material-ui/core/Radio';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab
} from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import AmountInput from '../Inputs/AmountInput'
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  addPartyCharge,
} from "../../../store/actions/tripActionCreator";
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
import inputStyles from '../css/inputs'
import { trackDwebEvent } from '../../analytics';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AddDriver from '../AddDialogComponent/AddDialogComponent';
import addStyles from '../css/addEditTrip';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import { OnChange } from 'react-final-form-listeners';
import { data } from 'jquery';
import * as logger from '../../../logger';
import TextInputState from '../Inputs/TextInputState';
import { addBankDetails, checkIfscCode, getBankDetails, markDefaultBank } from '../../../store/actions/OnlinePaymentActionCreators';
import AddIcon from '@material-ui/icons/Add';
import { VerifiedBankAccount, UnVerifiedBankAccount } from '../TopCard/icons';
import AddBankDetailsDialog from '../Bank/AddBankDetailsDialog';
import SuccessDialog from '../Verfication/SuccessDialog';
import FailureDialog from '../Verfication/FailureDialog';

const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  switchControl: {
    marginTop: 16,
    marginBottom: 8
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  expenseTypeListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%'
  },
  addExpenseListItem: {
    padding: '12px 15px',
    margin: 0,
    backgroundColor: '#0b1323',
    color: '#fff',
    fontWeight: 300,
    minHeight: 46,
    width: '100%',
    maxHeight: 46
  },
  addExpenseIcon: {
    color: '#fff',
    marginRight: 10
  },
  cherveRightIcon: {
    marginLeft: 10,
    float: 'right',
    color: '#fff'
  },
  listBoxAutoCompelete: {
    margin: 0,
    padding: 0
  },
  listBoxOption: {
    padding: 0,
    minHeight: 46,
    maxHeight: 46,
    borderBottom: '1px solid #eaedf3',
    "&:first-child": {
    },
    "&:last-child": {
    }
  },
  popUpIndicator: {
    display: 'none'
  },
  infoDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  nameDiv: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },
  subTitleSec: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  subTitleTxt: {
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(11, 19, 35, 0.5)"
  },
  driverDetailsDiv: {
    padding: "16px 24px",
    borderRadius: 8,
    border: "solid 1px #dcdcdc",
    backgroundColor: " #ededed",
    marginBottom: 24,
    marginTop: 2
  },
  titleV2: {
    fontSize: 14,
    fontWeight: 600,
    color: '#6b778c',
    marginBottom: 4
  },
  newInput: {
    backgroundColor: '#fff',
    border: "solid 1px #dedede",
    "& .MuiInputBase-input": {
      paddingTop: 12,
      paddingBottom: 12
    }
  },
  formControlInput: {
    marginBottom: 16
  },
  selectionDiv: {
    marginBottom: 12,
    marginLeft: 0,
    marginRight: 0,
    padding: 16,
    borderRadius: 8,
    border: "solid 0.5px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#ffffff",
    "& .MuiFormControlLabel-label": {
      width: "100%"
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: '#0033cc'
    }
  },
  primary: {
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'capitalize',
  },
  primaryUPI: {
    fontSize: 14,
    fontWeight: 600,
  },
  secondary: {
    textTransform: 'capitalize',
    fontSize: 14
  },
  info: {
    display: "flex",
    justifyContent: 'space-between',
    marginBottom: 4,
    "&:last-child": {
      marginBottom: 0
    }
  },
  verifiedAccount: {
    fontSize: 12,
    color: "rgba(21, 128, 38, 0.6)"
  },
  unVerifiedAccount: {
    fontSize: 12,
    color: "#e93333"
  },
  addBankDetailsButton: {
    marginTop: 24,
    padding: "12px 16px",
    borderRadius: 4,
    border: "solid 1px #0033cc",
    backgroundColor: "#fff",
    fontSize: 16,
    fontWeight: 600,
    color: "#0033cc",
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#fff",
    }
  },
  widthV1: {
    minWidth: 152
  },
  saveButtonDisabled: {
    backgroundColor: '#dadada !important',
    color: '#5e636c !important',
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    fontSize: 14,
    fontWeight: 300,
    height: 36,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#dadada'
    }
  },

}));
const BlueRadio = withStyles({
  root: {
    color: '#0033cc',
    '&$checked': {
      color: '#0033cc',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);
const BankDetailsSelectionDialog = (props) => {
  let ifscRegex = "^[A-Z]{4}0[A-Z0-9]{6}$";
  const componentClasses = useStyles();
  const inputClasses = inputStyles();
  let submit
  const {
    user,
    type,
    selectedData,
    onConfirm,
    classes,
    open,
    onClose,
    onSave,
    defaultSelected,
    location,
    editData,
    onUpdateSuccess,
    confirmText,
    trip,
    vehicle,
    dispatchAddBankDetailsAction,
    dispatchValidateIfsc,
    dispatchFetchBankDetails,
    dispatchMarkDeafultBank,
    calledFromInfo,
    allocatedAmountSingleSupplier,
    ...other
  } = props;
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];

  const [defaultBank, setDefaultBank] = React.useState(null);
  const [bankList, setBankList] = React.useState([]);
  const [bankDataList, setBankDataList] = React.useState([]);
  const [addBankDetails, setAddBankDetails] = useState(false);
  const [successCreation, setSuccessCreation] = useState(false);
  const [failureCreation, setFailureCreation] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(true);

  const handleSuccessOpen = () => {
    setSuccessCreation(true)
  }
  const handleSuccessClose = () => {
    setSuccessCreation(false)
  }
  const handleFailureOpen = () => {
    setFailureCreation(true)
  }
  const handleFailureClose = () => {
    setFailureCreation(false)
  }
  const handleChange = (event, newValue) => {

  };
  const handleFormSave = (e) => {
  }
  const handleAddBankClose = () => {
    setAddBankDetails(false)
  }
  const handleAddBankSave = (status) => {
    if (status) {
      handleSuccessOpen()
      setTimeout(() => {
        handleSuccessClose()
      }, 3000);
    } else {
      handleFailureOpen()
      setTimeout(() => {
        handleFailureClose()
      }, 3000);
    }
    let reqData = {
      type: type,
      id: selectedData && selectedData.id ? selectedData.id : ""
    }
    dispatchFetchBankDetails(reqData, (response) => {
      if (response && response.status && response.status.code == 200 && response.response && response.response.length > 0) {
        let bank = response.response.filter(v => v && v.is_default);
        if (bank && bank[0] && bank[0].id) {
          setDefaultBank(`${bank[0].id}`);
        }
        setBankList(response.response)
        setAddBankDetails(false)
      }
    }, () => {

    })
  }
  const handleAddBankOpen = () => {
    setAddBankDetails(true)
  }
  const handleClose = (status) => {
    onClose(false);
  };
  const createBankDataList = (bankList) => {
    let data = bankList.map((bank) => {
      return {
        value: `${bank.id}`,
        disabled: bank && !bank.broker_verification_status ? true : false,
        label: <div>
          <div className={componentClasses.info}>
            {bank && bank.acc_type && bank.acc_type == 'BANK'&&<Typography className={componentClasses.primary} >{bank && bank.acc_holder_name ? bank.acc_holder_name.toLowerCase() : ""}</Typography>}
            {bank && bank.acc_type && bank.acc_type == 'UPI'&&<Typography className={componentClasses.primaryUPI} >{bank && bank.upi_address ? bank.upi_address : ""}</Typography>}
            {bank && bank.broker_verification_status && <Typography><span className={componentClasses.verifiedAccount}>Verified Account</span>&nbsp;<VerifiedBankAccount /></Typography>}
            {bank && !bank.broker_verification_status && <Typography><span className={componentClasses.unVerifiedAccount}>Verification failed</span>&nbsp;<UnVerifiedBankAccount /></Typography>}
          </div>
          {bank && bank.acc_type && bank.acc_type == 'BANK' && <div className={componentClasses.info} >
            <Typography className={componentClasses.secondary} >{bank && bank.bank_name ? bank.bank_name.toLowerCase() : ""}</Typography>
            <Typography className={componentClasses.widthV1}>Acc No:&nbsp;<span className={componentClasses.primary}>{bank && bank.acc_number ? bank.acc_number : ""}</span></Typography>
          </div>}
        </div>
      }
    })
    return data
  }
  useEffect(() => {
    let reqData = {
      type: type,
      id: selectedData && selectedData.id ? selectedData.id : ""
    }
    dispatchFetchBankDetails(reqData, (response) => {
      if (response && response.status && response.status.code == 200 && response.response && response.response.length > 0) {
        let bank = response.response.filter(v => v && v.is_default);
        if (bank && bank[0] && bank[0].id && bank[0].broker_verification_status) {
          setDefaultBank(`${bank[0].id}`);
        }
        setBankList(response.response)
      }
    }, () => {

    })
  }, [])
  const getSubTitle = (type) => {
    switch (type) {
      case "SUPPLIER":
        return "Supplier Name";
      case "KHATA_SHOP":
        return "Shop Name";
      case "DRIVER":
        return "Driver Name";
      case "CUSTOMER":
        return "Party Name";
      case "FASTTAG":
        return "Fastag Vehicle Number";
      default:
        return null
    }
  }
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);

    const selectedBankInfo = bankList.filter((bankData) => bankData.id == values.defaultBank);

    dispatchMarkDeafultBank({ id: Number(values.defaultBank) }, (response) => {
      if (response && response.status && response.status.code == 200) {

        if (type == "SUPPLIER") {
          const vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";
          if (calledFromInfo == "singleTrip") {
            trackDwebEvent('Dweb STP Supplier payout bank account marked default', {
              trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
              trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
              supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
              supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
              trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
              vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
              vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
              origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
              destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
              supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
              bank_account_id: values && values.defaultBank ? values.defaultBank : "",
              verification_status: response && response.response && response.response.broker_verification_status ? response.response.broker_verification_status : ""
            });
          } else if (calledFromInfo == "singleSupplier") {
            trackDwebEvent('Dweb single supplier payout supplier bank account marked default', {
              vendor_id: vendorIdValue ? vendorIdValue : "",
              vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
              // vendor_contact_number,
              vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
              supplier_payout_amount: allocatedAmountSingleSupplier ? allocatedAmountSingleSupplier : 0,
              bank_account_number: selectedBankInfo && selectedBankInfo.acc_number ? selectedBankInfo.acc_number : "",
              ifsc_code: selectedBankInfo && selectedBankInfo.ifsc_code ? selectedBankInfo.ifsc_code : "",
              account_holder_name: selectedBankInfo && selectedBankInfo.acc_holder_name ? selectedBankInfo.acc_holder_name : "",
              bank_account_id: selectedBankInfo && selectedBankInfo.id ? selectedBankInfo.id : "",
              verification_status: response && response.response && response.response.broker_verification_status ? response.response.broker_verification_status : ""
            });
          }
        } else if (type == "DRIVER") {

          trackDwebEvent('Dweb Driver payout bank account marked default', {
            driver_id: selectedData && selectedData.id ? selectedData.id : "",
            driver_name: selectedData && selectedData.name ? selectedData.name : "",
            driver_balance: selectedData && selectedData.driverBalance ? selectedData.driverBalance : "",
            bank_account_id: selectedBankInfo && selectedBankInfo.id ? selectedBankInfo.id : "",
            verification_status: response && response.response && response.response.broker_verification_status ? response.response.broker_verification_status : ""
          })

        }else if (type == "KHATA_SHOP") {

          trackDwebEvent('Dweb Shop payout bank account marked default', {
            shop_id: selectedData && selectedData.id ? selectedData.id : "",
            shop_name: selectedData && selectedData.name ? selectedData.name : "",
            shop_balance: selectedData && selectedData.balance ? selectedData.balance : "",
            bank_account_id: response && response.response && response.response.id ? response.response.id : "",
            verification_status: response && response.response && response.response.broker_verification_status ? response.response.broker_verification_status : ""
          })

        }

        sendSucces("Default Bank Account Changed Successfully");
        onSave(true);
      } else {
        onSave(false);
      }
    }, () => {
      onSave(false);
    })
  };
  const validate = async values => {
    const errors = {};

    if (!values.defaultBank) {
      errors.defaultBank = "Please Select a Bank Account";
    }

    const selectedBank = bankList.filter((bankData) => bankData.id == values.defaultBank);

    if (selectedBank && selectedBank[0] && !selectedBank[0].broker_verification_status) {
      errors.defaultBank = "Please select a verified Bank Account"
    }

    if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
      setConfirmDisabled(true);
    } else {
      setConfirmDisabled(false);
    }


    return errors;
  }

  const getFormFields = (values) => {
    return [{
      size: 12,
      visible: bankList && bankList.length > 0,
      inline: false,
      field: (
        <>
          <Radios
            label=""
            name="defaultBank"
            required={true}
            formControlProps={{
              margin: 'none',
              className: componentClasses.billingTypeRadio,
              fullWidth: true
            }}
            onChange={(e) => {
              setDefaultBank(e.target.value)
            }}
            formControlLabelProps={{
              //control:<BlueRadio />,
              className: componentClasses.selectionDiv
            }}
            radioGroupProps={{ row: false }}
            data={
              createBankDataList(bankList && bankList.length > 0 ? bankList : [])
            }
          />
        </>
      ),
    },
    {
      size: 12,
      visible: true,
      inline: false,
      field: (
        <>
          <Button className={componentClasses.addBankDetailsButton} variant='outlined' onClick={() => { handleAddBankOpen() }}>
            <AddIcon />
            {type == "DRIVER" &&
              <>
                Add Driver’s Bank Account
              </>
            }
            {type == "SUPPLIER" &&
              <>
                Add Supplier's Bank Account
              </>
            }
             {type == "KHATA_SHOP" &&
              <>
                Add Shop's Bank Account
              </>
            }
          </Button>
        </>
      ),
    }]
  }

  let initialValues = {
    defaultBank: defaultBank
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"title-for-select-bank-details"}
        open={open}
      >
        <DialogTitle id={"title-for-select-bank-details"} onClose={handleClose}>
          {'Select Bank Account'}
        </DialogTitle>
        <TripActionDialogContent dividers>
          <div className={componentClasses.driverDetailsDiv}>
            <div className={componentClasses.subTitleSec} >
              <Typography className={componentClasses.subTitleTxt}>{getSubTitle(type)}</Typography>
            </div>
            <div className={componentClasses.infoDiv}>
              <div className={componentClasses.nameDiv}>
                <Typography className={componentClasses.listDriverName}>
                  {selectedData && selectedData.name ? selectedData.name : ""}
                </Typography>
              </div>
            </div>
          </div>
          <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={0}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                </form>
              )
            }}
          />
        </TripActionDialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" className='modal-save-cta' onClick={event => submit(event)} disabled={confirmDisabled} classes={{ disabled: componentClasses.saveButtonDisabled }} >
            {confirmText ? confirmText : 'Make Default'}
          </Button>
        </DialogActions>
      </Dialog>
      {addBankDetails && <AddBankDetailsDialog type={type} selectedData={selectedData} open={addBankDetails} onClose={handleAddBankClose} onSave={handleAddBankSave} calledFrom={calledFromInfo} />}
      {successCreation && <SuccessDialog open={successCreation} title={"Account Verified Successfully"} onClose={handleSuccessClose} />}
      {failureCreation && <FailureDialog open={failureCreation} title={"Account Verification Failed"} subTitle={"Please Re-Check the Bank Account details"} onClose={handleFailureClose} />}
    </div>
  );
}
const BankDetailsSelectionDialogWithRouter = withRouter(BankDetailsSelectionDialog);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddBankDetailsAction: (data, onSuccess, onError) => dispatch(addBankDetails(data, onSuccess, onError)),
  dispatchValidateIfsc: (data, onSuccess, onError) => dispatch(checkIfscCode(data, onSuccess, onError)),
  dispatchFetchBankDetails: (data, onSuccess, onFailure) => (dispatch(getBankDetails(data, onSuccess, onFailure))),
  dispatchMarkDeafultBank: (data, onSuccess, onFailure) => (dispatch(markDefaultBank(data, onSuccess, onFailure))),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BankDetailsSelectionDialogWithRouter);